// apps/scheduler-worker/src/hooks/useTask.ts
import { useQuery } from '@tanstack/react-query';
import { fetchTask, type TaskDetailResponse } from '../lib/api';

/**
 * Hook to fetch a single task's details by ID.
 */
export function useTask(taskId: string | undefined) {
  return useQuery<TaskDetailResponse>({
    queryKey: ['task', taskId],
    queryFn: () => {
      if (!taskId) throw new Error('Task ID is required');
      return fetchTask(taskId);
    },
    enabled: !!taskId,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
